import { concatMap } from "rxjs";
import generateSecureToken from "../../../utils/generateSecureToken";
import { apiService } from "../../ApiService";

export const amazonSubscribeUpdate = (opts: any) => {
  return generateSecureToken(apiService.userAgent).pipe(
    concatMap((secureToken) => {
      return apiService.put<unknown>({
        path: `v1/amazon/subscription`,
        body: { ...opts },
        secureToken,
        requiresAuthPolicy: undefined,
      });
    }),
  );
};
